import { render, staticRenderFns } from "./countryListRisk.vue?vue&type=template&id=15a04020&scoped=true&"
import script from "./countryListRisk.vue?vue&type=script&lang=js&"
export * from "./countryListRisk.vue?vue&type=script&lang=js&"
import style0 from "./countryListRisk.vue?vue&type=style&index=0&id=15a04020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a04020",
  null
  
)

export default component.exports